import { z } from "zod";

export const interviewRecordSchema = z.object({
  id: z.number(),
  content: z.string(),
  updated_by: z.string().nullish(),
  updated_at: z.coerce.date().nullish(),
});

export const interviewRecordUpdateSchema = interviewRecordSchema.omit({
  updated_by: true,
  updated_at: true,
});

export type InterviewRecord = z.infer<typeof interviewRecordSchema>;
export type InterviewRecordUpdate = z.infer<typeof interviewRecordUpdateSchema>;
